<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:0em;">Growing up in New Zealand, Penelope was inspired by her Nana, a well-published author and storyteller. From a young age, her Nana taught her to write down the feelings she found difficult to express.</p><br/>
<p style="text-indent:0em;">Her first published book, To My Lost Son, shares the journey of a grieving mother, from devastation to acceptance, through poetry.</p><br/>
<p style="text-indent:0em;">Her passion has always been in fast-paced thrillers. Meet the characters and share in their lives in Penelope's first mystery thriller.</p><br/>
<p style="text-indent:0em;">Follow Penelope on Facebook to find out about her future books first.</p><br/>
<p style="text-indent:0em;">https://www.facebook.com/profile.php?id=61557171111148&amp;mibextid=ZbWKwL</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?25f2a58c